const banner = document.querySelector("#info-banner");

if (banner) {
    const bannerContent = banner.querySelector(".info-banner__marquee__content");
    const bannerContentWidth = bannerContent?.scrollWidth;

    // Set width of banner content to banner as CSS variable
    if (bannerContent) {
        banner.style.setProperty(
            "--banner-content-width",
            `${bannerContentWidth}px`
        );
    }

    // Add eventlistener for load and resize event
    document.addEventListener("DOMContentLoaded", (e) => toggleBannerScrollAnimation(banner, bannerContentWidth));
    window.addEventListener("resize", (e) => toggleBannerScrollAnimation(banner, bannerContentWidth));

}

/**
 * Helper function to toggle the scroll animation because of content overflow on the info banner.
 * @param {*} banner HTML element of info banner
 * @param {Int} contentWidth Width of the banner content in pixels
 */
function toggleBannerScrollAnimation(banner = undefined, contentWidth = 0) {
    if (!banner) return; // Fallback if banner element is missing as function param

    // Get width of scroll area
    let scrollAreaWidth = banner.querySelector(".info-banner__marquee").offsetWidth;
    scrollAreaWidth = scrollAreaWidth - 40; // Substract right padding of container from value
    scrollAreaWidth = scrollAreaWidth < 0 ? 0 : scrollAreaWidth; // Set 0 as min. value

    // Condition to check if scroll animation is required
    const scrollAnimationRequired = scrollAreaWidth <= contentWidth;

    if (scrollAnimationRequired) {
        // Add scroll animation
        banner.classList.add("has-animation");
    } else {
        // Remove scoll animation
        banner.classList.remove("has-animation");
    }

}